import { atom } from 'recoil';

type EmailEditorNavigationState = {
  currentStep: number;
  hideWizardBottomNavigation: boolean;
  isComplete: boolean;
  isEditorLoading: boolean;
  isNextButtonEnabled: boolean;
};

export const isEmailEditorEnabled = atom<boolean>({
  key: 'isEmailEditorEnabled',
  default: false,
});

export const emailEditorNavigationState = atom<EmailEditorNavigationState>({
  key: 'emailEditorNavigationState',
  default: {
    currentStep: 0,
    isComplete: false,
    isEditorLoading: false,
    isNextButtonEnabled: false,
    hideWizardBottomNavigation: false,
  },
});

export const nodeGraphLoadingState = atom<boolean>({
  key: 'isNodeGraphLoading',
  default: false,
});
